import { createFileRoute } from '@tanstack/react-router';
import { CashPage } from '@/features/accounting/cash-page';
import { AccountingGuard } from '@/features/accounting/guard';

export const Route = createFileRoute('/_app/accounting/cash')({
  // ?a=<account id> — the ledger ⌘K sent us to opens instead of the first account
  validateSearch: (s: Record<string, unknown>): { a?: string } => ({ a: typeof s.a === 'string' && s.a ? s.a : undefined }),
  component: function Cash() {
    const { a } = Route.useSearch();
    return (
      <AccountingGuard>
        <CashPage accountId={a} />
      </AccountingGuard>
    );
  },
});
